export enum CHARACTER_TYPE {
  COURSE_CHARACTER = 0,
  INSTAGRAM_STORY_CHARACTER = 1,
  INSTAGRAM_POST_CHARACTER = 2,
  LINKEDIN_POST_CHARACTER = 3,
}

export default CHARACTER_TYPE;
